/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popUpgradeWarehouse.vue?vue&type=template&id=5316b6bb"
import script from "./popUpgradeWarehouse.vue?vue&type=script&lang=js"
export * from "./popUpgradeWarehouse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports